var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyJustX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u2716",
    clipPath: "url(#clip0_452_477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3435 16.4999C15.0235 16.4999 14.7035 16.3779 14.4595 16.1339L3.9595 5.63387C3.471 5.14587 3.471 4.35438 3.9595 3.86637C4.4475 3.37788 5.2395 3.37788 5.727 3.86637L16.227 14.3664C16.7155 14.8544 16.7155 15.6459 16.227 16.1339C15.983 16.3779 15.6635 16.4999 15.3435 16.4999Z",
    fill: "#EF4452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.8435 16.4999C4.5235 16.4999 4.2035 16.3779 3.9595 16.1339C3.471 15.6459 3.471 14.8544 3.9595 14.3664L14.4595 3.86589C14.9475 3.37739 15.7395 3.37739 16.227 3.86589C16.7155 4.35389 16.7155 5.14539 16.227 5.63339L5.727 16.1334C5.483 16.3774 5.163 16.4994 4.843 16.4994L4.8435 16.4999Z",
    fill: "#EF4452"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyJustX);
export default __webpack_public_path__ + "static/media/daily_just_x.e4230a9d9118f3195bffec22c64fea08.svg";
export { ForwardRef as ReactComponent };